export function enabledChecker(
  options: { enabled?: boolean } | undefined,
  requiredStr: string | undefined
) {
  return options?.enabled !== undefined
    ? options.enabled && !!requiredStr
    : !!requiredStr
}
